import { CheckCircle } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import WarningIcon from '@mui/icons-material/Warning';
import { Alert, Snackbar as MuiSnackbar } from '@mui/material';
import { FC, SyntheticEvent } from 'react';
import { ExtendedAlert } from './types';

/**
 * Notification Snackbar
 */
interface NotificationSnackbarProps {
  snackbarOpened: boolean;
  changeSnackbarState: (s: boolean) => void;
  message: ExtendedAlert | undefined;
}

const NotificationSnackbar: FC<NotificationSnackbarProps> = ({ snackbarOpened, changeSnackbarState, message }) => {
  const handleSnackbarClose = (_: Event | SyntheticEvent<Event, Event>, reason: string) =>
    reason !== 'clickaway' && changeSnackbarState(false);
  const closeSnackbar = () => changeSnackbarState(false);

  const icon = (() => {
    switch (message?.severity) {
      case 'success':
        return <CheckCircle />;
      case 'error':
        return <ReportProblemIcon />;
      case 'warning':
        return <WarningIcon />;
      case 'info':
        return <InfoIcon />;
      default:
        return <></>;
    }
  })();

  return (
    <MuiSnackbar
      open={snackbarOpened}
      onClose={handleSnackbarClose}
      autoHideDuration={message?.autoCloseAfterMills ?? 4000}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Alert
        onClose={closeSnackbar}
        severity={message?.severity}
        sx={{
          width: '100%',
        }}
        icon={icon}
      >
        {message?.message}
      </Alert>
    </MuiSnackbar>
  );
};

export default NotificationSnackbar;
